import api, { transformRequest, transformResponse } from "services/api";

export const desksApi = api
  .enhanceEndpoints({
    addTagTypes: ["Desks"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchDesks: build.query({
        query: () => "/api/v1/core/desks/",
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? [...results.map(({ id }) => ({ type: "Desks", id })), { type: "Desks", id: "LIST" }]
            : [{ type: "Desks", id: "LIST" }],
      }),
      addDesk: build.mutation({
        query: (payload) => ({
          url: "/api/v1/core/desks/create/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "Desks", id: "LIST" }],
      }),
      updateDesk: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/desks/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "Desks", id: "LIST" }],
      }),
      deleteDesk: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/desks/${payload.id}/delete/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "Desks", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useAddDeskMutation,
  useFetchDesksQuery,
  useDeleteDeskMutation,
  useUpdateDeskMutation,
} = desksApi;
